<template>
    <div class="quick-declare-summary-button-set">
        <div class="step-hint-bar">
            <div>確認申報清單，並下載媒體檔。</div>
        </div>
        <div class="upper">
            <!-- <el-tabs v-model="activeTab" @tab-click="onTabClick">
                <el-tab-pane label="銷項" name="Invoice"></el-tab-pane>
                <el-tab-pane label="進項" name="Payment"></el-tab-pane>
            </el-tabs> -->
            <div style="display: flex; align-items: center; gap: 12px;">
                <el-radio-group v-model="activeTab" size="" @change="onTabClick">
                    <el-radio-button label="Invoice">銷項 ({{ declaredInvoiceCount }})</el-radio-button>
                    <el-radio-button label="Payment">進項 ({{ declaredPaymentCount }})</el-radio-button>
                </el-radio-group>
                <div v-if="isDisplayModeTable" class="query-block">
                    <el-input v-model="foo" placeholder="發票號碼" size="" style="width: 160px" @keydown.enter.native="onSearch" />
                    <el-input v-model="buyBsn" placeholder="買方統編" size="" style="width: 130px" @keydown.enter.native="onSearch" />
                    <el-input v-model="saleBsn" placeholder="賣方統編" size="" style="width: 130px" @keydown.enter.native="onSearch" />
                    <money-input v-model="amt" placeholder="含稅金額" size="" style="width: 120px" is-search @keydown.enter.native="onSearch" />
                </div>
            </div>
            <slot name="action-right"></slot>
            <!-- <div>
                <el-radio-group v-model="displayMode" size="small">
                    <el-radio-button label="Table">清單</el-radio-button>
                    <el-radio-button label="MediaFile">媒體檔預覽</el-radio-button>
                </el-radio-group>
            </div> -->
            <!-- <el-button size="small" @click="displayMode === 'Table' ? displayMode = 'MediaFile' : displayMode = 'Table'">{{ displayMode === 'Table' ? '預覽媒體檔' : '關閉預覽媒體檔' }}</el-button> -->
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import {
    mapState, mapGetters, mapMutations, mapActions,
} from 'vuex';
import ExcelMixins from '@/components/dashboard/Accounting/BusinessTax/ExcelMixins';

export default {
    mixins: [ExcelMixins],
    data() {
        return {
            isLoading: false,
            activeTab: 'Invoice',
            foo: null,
            buyBsn: null,
            saleBsn: null,
            amt: null,
        };
    },
    created() {
        this.updateDeclaredQueryParams({
            activeTab: 'Invoice',
            foo: null,
            buyBsn: null,
            saleBsn: null,
            amt: 0,
        });
    },
    computed: {
        ...mapState({
            storeStep4DisplayMode: (state) => state.businessTax.step4DisplayMode,
            selectedInvoiceItems: (state) => state.businessTax.selectedInvoiceItems,
            selectedPaymentItems: (state) => state.businessTax.selectedPaymentItems,

            declaredInvoiceItems: (state) => state.businessTax.declaredInvoiceItems,
            declaredPaymentItems: (state) => state.businessTax.declaredPaymentItems,

            declaredInvoiceCount: (state) => {
                let data = [...state.businessTax.declaredInvoiceItems];
                if (state.businessTax.declaredQueryParams.foo) data = data.filter((o) => o.foo.includes(state.businessTax.declaredQueryParams.foo));
                if (state.businessTax.declaredQueryParams.buyBsn) data = data.filter((o) => o.bsn.includes(state.businessTax.declaredQueryParams.buyBsn));
                if (state.businessTax.declaredQueryParams.saleBsn) data = data.filter((o) => o.bsn.includes(state.businessTax.declaredQueryParams.saleBsn));
                if (state.businessTax.declaredQueryParams.amt) data = data.filter((o) => o.amt === state.businessTax.declaredQueryParams.amt);

                return data.length;
            },
            declaredPaymentCount: (state) => {
                let data = [...state.businessTax.declaredPaymentItems];
                if (state.businessTax.declaredQueryParams.foo) data = data.filter((o) => o.foo.includes(state.businessTax.declaredQueryParams.foo));
                if (state.businessTax.declaredQueryParams.buyBsn) data = data.filter((o) => o.bsn.includes(state.businessTax.declaredQueryParams.buyBsn));
                if (state.businessTax.declaredQueryParams.saleBsn) data = data.filter((o) => o.bsn.includes(state.businessTax.declaredQueryParams.saleBsn));
                if (state.businessTax.declaredQueryParams.amt) data = data.filter((o) => o.amt === state.businessTax.declaredQueryParams.amt);

                return data.length;
            },

            data: (state) => state.businessTax.datas,
            periodList: (state) => state.businessTax.periodList,
            queryParams: (state) => state.businessTax.queryParams,
            isIncome: (state) => state.businessTax.queryParams.QueryType === 1,
            currentTableVueComponent: (state) => state.businessTax.currentTableVueComponent,
            declarePeriod: (state) => state.businessTax.declarePeriod,
            declarePeriodYear: (state) => _.find(state.businessTax.periodList, ['value', state.businessTax.declarePeriod]).year,

            statePeriod: (state) => state.businessTax.period,
            stateTimespan: (state) => state.businessTax.timespan,
        }),
        ...mapGetters({
            companyInfo: 'menu/companyInfo',
        }),

        displayMode: {
            get() {
                return this.storeStep4DisplayMode;
            },
            set(val) {
                this.setStep4DisplayMode(val);
                if (val === 'MediaFile') this.setMediaFile();
            },
        },
        isDisplayModeTable() {
            return this.displayMode === 'Table';
        },
    },
    methods: {
        ...mapMutations({
            onClearSelection: 'businessTax/onClearSelection',
            updateQuery: 'businessTax/updateQuery',
            setPeriod: 'businessTax/setPeriod',
            setTimespan: 'businessTax/setTimespan',
            setStep4DisplayMode: 'businessTax/setStep4DisplayMode',
            setStep4MediaFileData: 'businessTax/setStep4MediaFileData',
            updateDeclaredQueryParams: 'businessTax/updateDeclaredQueryParams',
        }),
        ...mapActions({
            updateData: 'businessTax/updateData',
            updateDeclaredData: 'businessTax/updateDeclaredData',
        }),

        setMediaFile() {
            const target = [...this.declaredPaymentItems, ...this.declaredInvoiceItems];
            const formatted = this.getUploadFormat(target);
            this.setStep4MediaFileData(formatted);

            // this.onDownload(`${this.companyInfo.bsn || '無公司統編'}.txt`, formatedTxt);
        },
        getUploadFormat(items) {
            const row = [];
            items.forEach((item, i) => {
                const IS_INCOME = !!item.ioo || !!item.tioo;
                // eslint-disable-next-line eqeqeq
                const IS_CODE_22 = item.code == 22;
                const IS_INCOME_TYPE_2 = IS_INCOME && item.typ === 2;
                const IS_PAYMENT_TYPE_2 = !IS_INCOME && item.filE_TYP === 2;

                const CODE = item.code;
                const TAX_STATUS = this.getPaddingString(this.companyInfo.taX_BOO, 9);
                const SERIAL = this.getPaddingString(i + 1, 7);
                const DATE = this.getROCDateFormat(IS_INCOME && item.typ < 0 ? item.orI_FOO_DAT : item.foO_DAT);
                let BUYER_NUM = this.getPaddingString(IS_INCOME ? item.bsn || '        ' : this.companyInfo.bsn, 8);
                const SELLER_NUM = this.getPaddingString(IS_INCOME ? this.companyInfo.bsn : item.bsn, 8);
                let INVOICE_NUM = item.foo;
                let TAXATION = IS_INCOME ? item.tax : 1;

                let TAX_AMT = this.getPaddingString(this.getUploadFormatTaxAmount(item), 10);
                const NON_TAX_AMT = item.amt - this.getUploadFormatTaxAmount(item);
                let BILL_AMT = this.getPaddingString(NON_TAX_AMT, 12);
                const DEDUCT_CODE = IS_INCOME ? ' ' : 1;

                // 作廢
                if (item.foO_CNL) {
                    TAXATION = 'F';
                    BUYER_NUM = '        ';
                    BILL_AMT = this.getPaddingString(0, 12);
                    TAX_AMT = this.getPaddingString(0, 10);
                }

                // 車票單據號碼
                if (IS_CODE_22) INVOICE_NUM = this.getReceiptFormatFoo(item.foo);

                // 二聯式或發票銷售額需填寫含稅金額
                if (IS_INCOME_TYPE_2 || IS_PAYMENT_TYPE_2 || IS_CODE_22) {
                    BILL_AMT = this.getPaddingString(item.amt, 12);
                    TAX_AMT = this.getPaddingString(0, 10);
                }

                row.push(
                    // eslint-disable-next-line max-len
                    `${CODE}${TAX_STATUS}${SERIAL}${DATE}${BUYER_NUM}${SELLER_NUM}${INVOICE_NUM}${BILL_AMT}${TAXATION}${TAX_AMT}${DEDUCT_CODE}`,
                );
            });

            return row;
        },
        getUploadFormatTaxAmount(item) {
            return item.typ === undefined ? item.tax : item.amT_TAX;
        },

        getPaddingString(num, paddingLength) {
            return `${num}`.padStart(paddingLength, '0');
        },
        getROCDateFormat(timestamp) {
            const TIME = moment(timestamp);
            return `${TIME.year() - 1911}${TIME.format('MM')}`;
        },
        getReceiptFormatFoo(foo) {
            const FOO = foo.replaceAll('-', '');
            if (FOO.length < 10) return this.getPaddingString(foo, 10);
            return FOO.substring(FOO.length - 10, FOO.length);
        },

        onTabClick() {
            this.updateDeclaredQueryParams({
                activeTab: this.activeTab,
                foo: this.foo,
                buyBsn: this.buyBsn,
                saleBsn: this.saleBsn,
                amt: this.amt,
            });
            this.$emit('update:activeTab', this.activeTab);
        },
        onSearch() {
            this.updateDeclaredQueryParams({
                foo: this.foo,
                buyBsn: this.buyBsn,
                saleBsn: this.saleBsn,
                amt: this.amt,
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.quick-declare-summary-button-set {
    .upper {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 15px;
        width: 100%;
        border-bottom: 1px solid #e1e1e1;
    }
    .query-block {
        display: flex;
        flex: 1;
        justify-content: flex-end;
        padding: 0 0px;
        max-width: 800px;
        gap: 10px;
        > * {
            width: 170px;
        }

        .el-input {

        }
    }

    .bottom {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 30px 20px 30px;
        width: 100%;
    }
    // margin-bottom: 10px;
}
</style>

<style lang="scss">
.quick-declare-summary-button-set {
    display: flex;
    flex-direction: column;
    width: 100%;

    .step-hint-bar {
        display: flex;
        align-items: center;
        justify-content: center;
        // background-color: #eae9fd;
        background-color: #f7ee9f;
        color: #482911;
        // color: #453d9e;
        border-bottom: 1px solid #eee;

        font-size: 10pt;
        height: 46px;
    }

    .el-tabs__active-bar {
        // background-color: #d9d9d9;
    }
    .el-tabs__nav-wrap::after {
        background-color: #fff;
    }
    .el-tabs__header {
        margin-top: 4px !important;
    }
    .el-tabs__item {
        font-weight: bold;
        color: #888;

        &.is-active {
            color: #463cb2;
        }
    }
}
</style>
